import {
  GenericApiService,
  IListApiResponse,
  ISingleApiResponse,
} from "src/api/API_GenericService";
import { GeneralEndpoints } from "src/constants/apiEndpoints";
import { IConfiguration } from "src/models/General/Configuration.models";
import { PaginationParams } from "src/shared/models/PaginationParams.models";
import {
  setConfigurationList,
  addConfiguration,
  updateConfiguration,
  deleteConfiguration,
  setConfigurationToEdit,
  concatListConfiguration,
} from "src/store/General/slices/configurationSlice";

const ApiService = new GenericApiService<IConfiguration>();

const GetAllConfigurationList = (dispatch: any, pagination?: PaginationParams) => {
  return new Promise<IListApiResponse<IConfiguration>>(async (resolve, reject) => {
    try {
      const response = await ApiService.getAll(
        GeneralEndpoints.configuration,
        pagination?.params
      );
      if (response?.success) {
        if (pagination?.concat) dispatch(concatListConfiguration(response?.data?.filter(x=>x.code != "INVOICE_RECEIVED_ONLY" )));
        else dispatch(setConfigurationList(response?.data?.filter(x=>x.code != "INVOICE_RECEIVED_ONLY" )));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const GetConfigurationById = (dispatch: any, id: number) => {
  return new Promise<ISingleApiResponse<IConfiguration>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.getById(
          GeneralEndpoints.configuration,
          id
        );
        if (response?.success) {
          dispatch(setConfigurationToEdit(response?.data));
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const GetServerDate = () => {
  return new Promise<ISingleApiResponse<Date>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.getByCode(
          GeneralEndpoints.configuration,
          'SERVER_DATE'
        );
        resolve(response as any);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const GetConfigurationByCode = (dispatch: any, id: string) => {
  return new Promise<ISingleApiResponse<IConfiguration>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.getByCode(
          GeneralEndpoints.configuration,
          id
        );
        if (response?.success) {
          dispatch(setConfigurationToEdit(response?.data));
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const AddNewConfiguration = (dispatch: any, newItem: IConfiguration) => {
  return new Promise<ISingleApiResponse<IConfiguration>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.create(
          GeneralEndpoints.configuration,
          newItem
        );
        if (response.success) {
          dispatch(addConfiguration(response?.data));
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const UpdateConfigurationOnList = (dispatch: any, newItem: IConfiguration) => {
  return new Promise<ISingleApiResponse<IConfiguration>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.update(
          GeneralEndpoints.configuration,
          newItem
        );
        if (response.success) {
          dispatch(updateConfiguration(response?.data));
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const DeleteConfiguration = (dispatch: any, newItem: IConfiguration) => {
  return new Promise<ISingleApiResponse<IConfiguration>>(
    async (resolve, reject) => {
      try {
        const toUpdated = { ...newItem };
        toUpdated.status = false;
        const response = await ApiService.update(
          GeneralEndpoints.configuration,
          toUpdated
        );
        if (response.success) {
          dispatch(deleteConfiguration(response?.data?.configurationId));
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

export {
  GetConfigurationById,
  GetServerDate,
  GetAllConfigurationList,
  AddNewConfiguration,
  UpdateConfigurationOnList,
  DeleteConfiguration,
  GetConfigurationByCode,
};
